import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
    selector: 'no-roles',
    templateUrl: './no-roles.component.html',
    styleUrls: ['./no-roles.component.css']
})

export class NoRolesComponent implements OnInit {
  private navbarHeadline: any;

  constructor() { }

  ngOnInit() {
    this.navbarHeadline = $('#navbarHeadline').html('');
  }
}
